import Breadcrumbs from 'components/atomic/Breadcrumbs'
import ListingAutori from 'components/ListingAutori'
import MetaSeo from 'components/atomic/MetaSeo'
import { PAGINEDETAIL } from 'utils/endpoint'
import { api } from 'utils'
import { useRouter } from 'next/router'

function AutoriAll({ pagina }) {
  const router = useRouter()
  const filtriInitial = router.query.filtri_id?.split('/').filter(Number).map(Number) || []

  return (
    <main className="autori-page">
      <MetaSeo seo={pagina.seo} />
      <div className="w-container">
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />

        <h1 className="autori-page__title">{pagina.titolo}</h1>

        <ListingAutori filtriInitial={filtriInitial} />
      </div>
    </main>
  )
}

export const getStaticProps = async () => {
  const response = await api.get(PAGINEDETAIL, { params: { chiave: 'autori-all' } })
  const pagina = await response.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps, key: pagina.id }, revalidate: 60 * 60 }
}

export default AutoriAll
